import React from 'react';
import { useEvents } from '~/core/events/eventsContext';

export type ClickLogoHandler = () => void;

export type UseLogoClickHandlerParams = {
    /** Used for analytics */
    searchQuery: string;
    /** Used for analytics */
    resultsCount: number;
    /** Used for analytics */
    loadingFinished: boolean;
    logoLink?: string;
};

export type LogoClickProperties = { clickLogoHandler: ClickLogoHandler; isLogoClickable: boolean };

export const useLogoClickHandler = ({
    searchQuery,
    resultsCount,
    loadingFinished,
    logoLink,
}: UseLogoClickHandlerParams): LogoClickProperties => {
    const {
        eventEmitter: { emitConfirmableEvent },
        eventFactory: { createCloseEvent },
    } = useEvents();

    return {
        clickLogoHandler: React.useCallback(() => {
            if (!logoLink) {
                return;
            }

            (async () => {
                const [aaConfirmation] = await emitConfirmableEvent(
                    createCloseEvent({
                        searchQuery,
                        resultsCount,
                        loadingFinished,
                        serpType: 'full',
                    }),
                    150
                );

                window.location.href = logoLink;
            })();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [searchQuery, resultsCount, loadingFinished, logoLink]),
        isLogoClickable: Boolean(logoLink),
    };
};
